import { Injectable } from '@angular/core';
import { AlertController, ToastController } from 'ionic-angular';


/*
  Generated class for the AlertService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class AlertService {

  constructor(private alertCtrl: AlertController,
          private toastCtrl: ToastController) { }

  //Alerta Simples
  mostraAlerta(titulo, mensagem) {
    let alert = this.alertCtrl.create({
      title: titulo,
      message: mensagem,
      buttons: ['OK']
    });
    alert.present();
  }

  //Modal de confirmação
  mostraModalConfirmacao(titulo, mensagem, callback) {
    let alert = this.alertCtrl.create({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          text: 'Cancelar',
          handler: () => {
            callback(false);
          }
        },
        {
          text: 'Confirmar',
          handler: () => {
            callback(true);
          }
        }
      ]
    });
    alert.present();
  }

  mostraModalInformativo(titulo, mensagem) {
    let alert = this.alertCtrl.create({
      title: titulo,
      message: mensagem,
      buttons: ['Dismiss']
    });
    alert.present();
  }

  mostrarToast(mensagem: string) {
    let toast = this.toastCtrl.create({
      message: mensagem,
      duration: 3000,
      position: 'bottom'
    });
  
  /*   toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    }); */
  
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/alert-service.ts